<template>
    <div class="row file-data-thumbnail-container">
        <div class="col-3">
            <div class="image-wrapper" style="text-align: center;">
                <img :src="media.base_64_thumbnail"
                     v-if="isImage"
                     @click="emitShowMedia">

                <span class="icon"
                      :class="{
                        'bi-file-word': isWord,
                        'bi-file-pdf': isPdf,
                        'bi-file-ppt': isPpt,
                        'bi-file-excel': isExcel,
                        'bi-file-text': isText,
                        'bi-files': isFile
                      }"
                      style="font-size: 36pt; cursor: pointer;"
                      v-else
                      @click="download">
                </span>
            </div>
        </div>

        <div class="col-9">
            <div class="row">
                <div class="col-12">
                    <div class="file-info-container">
                        <div class="file-name"
                             :title="media.name"
                             @click="emitChangeMediaName">
                            {{ media.name }}
                        </div>

                        <span class="uq-icon bi-x-circle"
                           @click="emitDeleteFile"></span>
                    </div>
                </div>

                <div class="col-12">
                    <span class="badge bg-warning">{{ media.mime_type }}</span>
                </div>

                <div class="col-12">
                    <span class="badge bg-dark"
                          style="cursor: pointer;"
                          @click="emitChangeMediaCategory">
                        {{ media.collection_display_name }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {download} from "../../../../helpers/requests/RequestsMedia";

export default {
    name: 'FileDataWithThumbnail',
    computed: {
        isPdf() {
            return this.media.name.includes('.pdf');
        },
        isWord() {
            return (this.media.name.includes('.doc') || this.media.name.includes('.docx'));
        },
        isExcel() {
            return (this.media.name.includes('.xls') || this.media.name.includes('.xlsx'));
        },
        isPpt() {
            return (this.media.name.includes('.ppt') || this.media.name.includes('.pptx'));
        },
        isText() {
            return this.media.name.includes('.txt');
        },
        isFile() {
            return !this.isPdf && !this.isWord && !this.isExcel && !this.isPpt && !this.isText;
        },
        isImage() {
            return this.media.mime_type.includes('image/');
        }
    },
    props: {
        media: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async download() {
            this.$store.dispatch('app/setToastMessage', 'Descargando fichero...');
            try {
                const link = document.createElement('a');
                link.href = await download(this.media.id);
                link.click();
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Ha habido un error al descargar el fichero');
            }
        },
        emitDeleteFile() {
            this.$emit('deleteFile', this.media);
        },
        emitShowMedia() {
            this.$emit('showMedia', this.media);
        },
        emitChangeMediaName() {
            this.$emit('changeMediaName', this.media);
        },
        emitChangeMediaCategory() {
            this.$emit('changeMediaCategory', this.media);
        }
    },

}
</script>
